/**
 * Insumos do Override de Ficha Técnica.
 * Subcoleção: org/{orgId}/technical-sheet-override/{overrideId}/input
 *
 * Locator de REMOVE/UPDATE: (processId, componentId) — chave de negócio estável.
 * UPDATE não troca componentId (ele é o locator); trocar = REMOVE + ADD.
 */
export const TECHNICAL_SHEET_OVERRIDE_INPUT = 'TechnicalSheetOverrideInput';
export const OverrideInputActionValues = ['ADD', 'REMOVE', 'UPDATE'];
//# sourceMappingURL=technical-sheet-override-input.js.map